import { AuthContext } from '@repo-level/core-front';
import { ImageComponent } from 'components/Image';
import { ProgressBarPalette } from 'components/progressBars/helpers';
import { SmallProgressBar } from 'components/progressBars/SmallProgressBar';
import { useTheme } from 'hooks/theme';
import { useCloverGoldPromo } from 'modules/clover-gold/hooks/useCloverGoldPromo';
import type { FC } from 'react';
import { memo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigation } from 'react-navi';
import cloverGoldImage from '../../../../../assets/images/clover-gold/clover-element.webp';
import { ScCloverGoldPanel } from './styled';

export interface ICloverGoldPanelProps {
  onLinkClick?: () => void;
  isMobile?: boolean;
}

export const CloverGoldPanel: FC<ICloverGoldPanelProps> = memo(
  ({ onLinkClick, isMobile }) => {
    const { t } = useTranslation('cloverGold');
    const { isAuthenticated } = useContext(AuthContext);

    const { navigate } = useNavigation();
    const { images } = useTheme();
    const { userProgress, cloverGoldData } = useCloverGoldPromo();

    return (
      <ScCloverGoldPanel
        $isAuthenticated={isAuthenticated}
        onClick={() => {
          onLinkClick?.();
          navigate('/clover-gold');
        }}
      >
        <div className="inner">
          {isMobile && (
            <ImageComponent
              alt="clover-gold img"
              height={56}
              src={cloverGoldImage}
              width={56}
            />
          )}
          <div className="content">
            <div className="title-wrapper">
              {!isMobile && (
                <ImageComponent
                  alt="clover-gold img"
                  height={24}
                  src={cloverGoldImage}
                  width={24}
                />
              )}

              <p className="title">{cloverGoldData?.title}</p>
            </div>
            {isAuthenticated ? (
              <div className="progress">
                <SmallProgressBar
                  config={{
                    dotsCount: 5,
                    color: ProgressBarPalette.GREEN,
                  }}
                  userProgress={userProgress}
                />
                <p className="progress-value">
                  <span className="your-progress">{t('yourProgress')}:</span>{' '}
                  {userProgress}%
                </p>
              </div>
            ) : (
              <p className="description">{t('yourRewards')}</p>
            )}
          </div>
          {isMobile && <images.arrowRightSmallIcon.component />}
        </div>
      </ScCloverGoldPanel>
    );
  }
);
